export default __webpack_public_path__ + "static/media/liquor-city.ff7c080a.jpg";